import axios from 'axios'
import Honeybadger from 'honeybadger-js'

class ContactService {
    static async sendContactInformation(data: any) {
        try {
            await axios.post(`${process.env.VUE_APP_SERVER}contact`, data)
        } catch (e) {
            Honeybadger.notify(e)
        }
    }
}

export {ContactService}